<div class="card-actuation header-actuation your-account m-b-6 proxima">
    <div class="title-height" fxLayout="row" fxLayoutAlign="space-between center">
        <div class="h3 pr-16 cardHeader">Agregar Tarea</div>
    </div>
    <app-task-management [task-operation]="taskOperation" [LeaveId]="LeaveId" [EmployeeId]="EmployeeId" id="new-task">
    </app-task-management>
</div>